import {put} from 'redux-saga/effects';
import {exceptionCaughtAction} from './actions';

export function* sendError(error) {
  yield put(exceptionCaughtAction(error));
}
